import type { SeasonStepKey } from "@api/generated/model";
import { Icon } from "@app/icons";
import { nextStep, SEASON_CYCLE, stepNumber } from "@app/seasonCycle";
import { Button } from "@mantine/core";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

/** "Tenyészidőszak · 2. lépés a 7-ből": where a workflow screen stands in the season cycle (a link to the home
 *  page's cycle). PageHeader shows it on the cycle's screens. */
export function SeasonStepChip({ step }: { step: SeasonStepKey }) {
  const { t } = useTranslation();
  return (
    <Link to="/" className="chip y season-step">
      {t("cycle.step", { n: stepNumber(step), total: SEASON_CYCLE.length })}
    </Link>
  );
}

/** "Tovább: Parcellaszámozás →": the step of the season cycle after ``after``. */
export function NextStepButton({ after }: { after: SeasonStepKey }) {
  const { t } = useTranslation();
  const next = nextStep(after);
  if (!next) return null;
  return (
    <Button component={Link} to={next.to} size="xs" className="btn-wrap" rightSection={<Icon name="arrowRight" size={14} />}>
      {t("cycle.next", { title: t(`home.steps.${next.key}.title`) })}
    </Button>
  );
}
